import { ChangeDetectorRef, Component, Input, NgZone, OnInit } from '@angular/core';
import { AudiofileService, TranscriptionResult } from '../../services/audiofile.service';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { DatePipe } from '@angular/common';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModalConfig, NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from '../../services/authentication.service';
import { ExcelDownloadService } from '../../services/excel-download.service';
import { ExcelService } from '../../services/excel.service';
import { MasterService } from '../../services/master.service';
import { RegistrationService } from '../../services/registration.service';
declare var MediaRecorder: any;
@Component({
  selector: 'app-audio-player',
  templateUrl: './audio-player.component.html',
  styleUrls: ['./audio-player.component.css']
})
export class AudioPlayerComponent implements OnInit {
  // @Input() audioFile?: File;
  @Input() form: any;
isLoading = false; error?: string;
  message = ''; captureResult: string | null = null; result?: TranscriptionResult;
  showPopup = true;
  isClosing = false;
  hoveringButton = false;
  hoveringPopup = false;
  closeTimeout: any;
  status = ''; recStatus = ''; transcript = '';
  filePath = ''; output: any = {}; isRecording = false;
  previewUrl?: SafeUrl; fileForUpload?: File;
  useDiarization: boolean = false;
  translateToEnglish = true;
  isCollapsed: boolean = true;
  modelSize = 'small';
  durationLable: string = 'Days';
  isPaused: boolean = false;
  private timerId: any; recordingSeconds = 0;
  recordedBlobUrl: SafeResourceUrl | null = null;
 recordedURL =false
 
  private chunks: Blob[] = [];
  recordedBlob: Blob | null = null;
  recorder: any;
  url: SafeResourceUrl;
  
  constructor(
    private cdr: ChangeDetectorRef,
    private api: AudiofileService,
    private zone: NgZone,
    config: NgbModalConfig
        , private modalService: NgbModal,
          public activeModal: NgbActiveModal
        , private toastr: ToastrService
        , private router: Router
        , private formBuilder: FormBuilder
        , private authSvc: AuthenticationService
        , private regService: RegistrationService
        , private datePipe: DatePipe,
        private excelDownloadService: ExcelDownloadService,
        private excelService: ExcelService
        , private spinnerService: NgxSpinnerService
        , private masterService: MasterService
        , private sanitizer : DomSanitizer
        , public changeDetection: ChangeDetectorRef
  ) { }

  ngOnInit(): void {

  }
  onFileSelected(event: Event) {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (!file) return;
    this.processFile(file);
  }
 
  async processFile(file?: File) {
    if (!file) return;
    this.status = 'Uploading...';
    try {
      // TODO: Replace with your API call
      const formData = new FormData();
      formData.append('audio', file);
      // await fetch('/api/process-audio', { method: 'POST', body: formData });
      this.status = 'Done';
      this.transcript = 'Sample transcript text';
      this.output = { transcript: this.transcript };
    } catch (e) {
      this.status = 'Error';
    }
  }
 
   async startRecording() {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
 
      // Reset state
      this.recordedBlob = null;
      this.recordedBlobUrl = null;
      this.chunks = [];
      this.recordingSeconds = 0;
      this.isPaused = false;
 
      this.recorder = new MediaRecorder(stream);
 
      this.recorder.ondataavailable = (event) => {
        if (event.data.size > 0) {
          this.chunks.push(event.data);
        }
      };
 
      this.recorder.onstop = () => {
        this.cdr.detectChanges(); // manually trigger change detection
  this.recordedBlob = new Blob(this.chunks, { type: 'audio/wav' });
  this.recordedBlobUrl = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(this.recordedBlob!));
  console.log('recordedBlobUrl', this.recordedBlobUrl);
  this.cdr.detectChanges(); // manually trigger change detection

        
 
        this.isRecording = false;
        this.stopTimer();
 
        stream.getTracks().forEach((track) => track.stop());
 
        setTimeout(() => {
          const audioEl = document.querySelector<HTMLAudioElement>('audio#playback');
          audioEl?.load();
        }, 0);
 
        this.cdr.markForCheck();
      };
 
      this.recorder.start();
      this.isRecording = true;
      this.startTimer();
      this.error = undefined;
 
    } catch (err) {
      this.error = 'Failed to start recording. Please check microphone permissions.';
      console.error('Recording error:', err);
    }
  }
 
  stopRecording() {
    if (this.recorder && this.recorder.state !== 'inactive') {
      this.recorder.stop();
    }
  }
 
  async uploadRecording() {
    if (!this.recordedBlob) {
      alert('No recording available');
      this.isLoading = true;
    }
    await this.transcribe();
  }
 
  transcribe(){
    this.isLoading = true;
  this.error = undefined;
  this.result = undefined;
 
  const file = this.fileForUpload || new File([this.recordedBlob!], 'recording.wav', { type: 'audio/wav' });
 
 this.api.transcribe(file, {
  useDiarization: this.useDiarization,
  translateToEnglish: this.translateToEnglish,
  modelSize: this.modelSize
})
.then((result: TranscriptionResult) => {
  this.result = result;
  this.isLoading = false;
  return this.prubloading();
})
.catch(error => {
  console.error('Error during transcription:', error);
  this.isLoading = false;
});

  }
 
 
 
  prubloading() {
    if (!this.result?.full_text) {
      this.error = 'No transcript available. Please transcribe audio first.';
      return;
    }
    this.isLoading = true;
    const payload: any = {
      transcript: this.result?.full_text,
      keys: (this.form.getRawValue()),
    };
   this.isLoading = true;

this.api.prubloading(payload)
  .then((response: any) => {
    return response;
    this.isLoading = false;
  })
  .catch((err) => {
    console.error('Error in prubloading:', err);
    this.isLoading = false;
  });

  }
 
   togglePauseResume() {
    if (!this.recorder || !this.isRecording) return;
 
    if (this.isPaused) {
      this.recorder.resume();
      this.isPaused = false;
      this.startTimer();
    } else {
      this.recorder.pause();
      this.isPaused = true;
      this.stopTimer();
    }
 
    this.cdr.markForCheck();
  }
 
  private startTimer() {
    this.stopTimer();
    this.timerId = setInterval(() => {
      this.zone.run(() => {
        this.recordingSeconds++;
      });
      this.cdr.markForCheck();
    }, 1000);
  }
 
  private stopTimer() {
    if (this.timerId) {
      clearInterval(this.timerId);
      this.timerId = null;
    }
  }
 
  onFileChange(event: Event) {
  const target = event.target as HTMLInputElement;
  if (target.files && target.files.length > 0) {
    this.fileForUpload = target.files[0];
    this.error = undefined;
  }
}
 
  togglePopup() {
  if (this.showPopup) {
    this.closePopup();
  } else {
    this.showPopup = true;
    this.isClosing = false;
  }
}
 
closePopup() {
  this.isClosing = true;
  clearTimeout(this.closeTimeout);
  this.closeTimeout = setTimeout(() => {
    this.showPopup = false;
    this.isClosing = false;
  }, 300); // must match CSS transition time
}
 
onButtonMouseLeave() {
  this.hoveringButton = false;
  setTimeout(() => this.checkHidePopup(), 100);
}
 
onPopupMouseEnter() {
  this.hoveringPopup = true;
}
 
onPopupMouseLeave() {
  this.hoveringPopup = false;
  setTimeout(() => this.checkHidePopup(), 100);
}
 
checkHidePopup() {
  if (!this.hoveringButton && !this.hoveringPopup) {
    this.closePopup();
  }
}

}
